import {
  PlatoContextQuery,
  PlatoProGiveAnswerRequest,
  PlatoProStartRequest,
} from "@shared/dtos/requests/platoRequests.dto"
import {
  PlatoProResponse,
  PlatoQuestionnaireResponse,
  PlatoSessionSummaryResponse,
} from "@shared/dtos/responses/platoResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getQuestionnaires = (params: PlatoContextQuery): Promise<PlatoQuestionnaireResponse[]> =>
  axiosAuth({
    url: "/plato/questionnaires",
    params,
    method: "get",
  }).then((resp) => resp.data)

export const start = (data: PlatoProStartRequest): Promise<PlatoProResponse> =>
  axiosAuth({
    url: "/plato/start",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const giveAnswer = (data: PlatoProGiveAnswerRequest): Promise<PlatoProResponse> =>
  axiosAuth({
    url: "/plato/answer",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const getSession = (id: string): Promise<PlatoSessionSummaryResponse> =>
  axiosAuth({
    url: `/plato/session/${id}`,
    method: "get",
  }).then((resp) => resp.data)
